import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Brain, Activity, Clock } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    icon: <Activity className="w-6 h-6 text-warm-accent" data-id="element-185" />,
    title: 'Miedo al movimiento',
    description: 'Sientes que cualquier mal gesto puede desencadenar una crisis y vives con la tensión constante de proteger tu espalda.'
  }, {
    icon: <Brain className="w-6 h-6 text-warm-accent" data-id="element-186" />,
    title: 'Agotamiento mental',
    description: 'El dolor constante no solo afecta tu cuerpo, drena tu energía, tu paciencia y tu capacidad de disfrutar el día a día.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-warm-accent" data-id="element-187" />,
    title: 'Información confusa',
    description: 'Un médico te dice reposo, otro te dice ejercicio. Buscas en internet y terminas con más dudas y miedo que antes.'
  }, {
    icon: <Clock className="w-6 h-6 text-warm-accent" data-id="element-188" />,
    title: 'La vida en pausa',
    description: 'Sientes que tu vida cambió de la noche a la mañana y has tenido que renunciar a cosas que antes te hacían feliz.'
  }];
  return <section className="py-24 bg-warm-bg relative" data-id="element-189">
      <div className="max-w-5xl mx-auto px-6" data-id="element-190">
        <FadeIn className="text-center mb-16" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-6" data-id="element-192">
            Sé exactamente cómo te sientes...
          </h2>
          <p className="text-lg text-warm-dark/70 max-w-2xl mx-auto" data-id="element-193">
            El dolor de espalda es invisible para los demás, pero lo abarca todo
            para quien lo sufre. La frustración y la soledad del diagnóstico son
            tan reales como el dolor físico.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-194">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} className="bg-white p-8 rounded-2xl shadow-sm border border-warm-alt/50" data-id="element-195">
              <div className="w-12 h-12 bg-warm-alt rounded-full flex items-center justify-center mb-6" data-id="element-196">
                {point.icon}
              </div>
              <h3 className="text-xl font-heading font-medium text-warm-dark mb-3" data-id="element-197">
                {point.title}
              </h3>
              <p className="text-warm-dark/70 leading-relaxed" data-id="element-198">
                {point.description}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-16 text-center" data-id="element-199">
          <p className="text-xl font-heading italic text-warm-accent" data-id="element-200">
            "No estás solo/a en esto. Tu dolor es válido, tu frustración tiene
            sentido, y hay un camino hacia adelante."
          </p>
        </FadeIn>
      </div>
    </section>;
}